// import Constants from '@/utils/Constants'

const state = {
	active: false,
	title: '',
	body: '',
	label: '閉じる'
}

const getters = {
	get: state => state
}

const actions = {
	show ({commit}, {title, body, label}) {
		// cover
		this.dispatch('core/showDialogCover')
		
		let parameters = {}
		if (title !== undefined) parameters.title = title
		if (body !== undefined) parameters.body = body
		if (label !== undefined) parameters.label = label
		commit('showed', parameters)
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideDialogCover')
		}, 350)
	}
}

const mutations = {
	showed (state, {title, body, label}) {
		if (title !== undefined) state.title = title
		if (body !== undefined) state.body = body
		if (label !== undefined) state.label = label
		state.active = true
	},
	hided (state) {
		state.active = false
		state.title = ''
		state.body = ''
		state.label = ''
	}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
